export default "__VITE_ASSET__CD39h2nx__"